import { SeaFutureOrderComponent } from './../sea-future-order/sea-future-order.component';
import { Component, Injector, OnInit, inject, viewChild } from '@angular/core';
import { jkAlert, JkBaseOption, JkComboboxComponent, JkdaterangeComponent, } from 'jk-service';
import { jkLib, idNameItem, jkRestReturn } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { StockService } from '../services/stock.service';
import { StkmbService } from '../services/stkmb.service';
import { StklmService } from '../services/stklm.service';
import { StkMarkettypeList } from '../services/stklmPkg.service';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

class FilterOption extends JkBaseOption { // ###
  dateA: string = jkLib.nowDate();
  dateB: string = jkLib.nowDate();
  kind: string = '';
  account: string = '';
}


@Component({
  selector: 'app-stkpq18',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
  templateUrl: './stkpq18.component.html',
  styleUrl: './stkpq18.component.css'
})
export class Stkpq18Component extends jkQueryComponent implements OnInit {
  private stkmbSrv = inject(StkmbService);
  stklmSrv = inject(StklmService);
  stockSrv = inject(StockService);

  readonly kindCom = viewChild.required<JkComboboxComponent>('kindCom');
  readonly accountCom = viewChild.required<JkComboboxComponent>('accountCom');
  readonly dateCom = viewChild.required<JkdaterangeComponent>('dateCom');
  override _programId = 'stkpq18'; // ### 回報查詢(stkpq18)
  filterOpt: FilterOption = new FilterOption(this.programId);//###
  accountList: idNameItem[] = [];
  get kind(): string {
    return this.filterOpt.kind;
  }
  set kind(value: string) {
    this.filterOpt.kind = value;
    this.kindValueChange(value);
  }
  kindList: idNameItem[] = StkMarkettypeList;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      this.kind = 'TS'; // 證券
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);

  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    try {
      this.type = 'S';
      this.winItem = 'S01';
      this.mainTable = 'STKLM';
      this.where = '';
      this.where = this.accountCom().addWhere(this.where, 'Broker+CustNo');
      this.where = this.dateCom().addWhere(this.where, 'Date1');
    } catch (error: any) {
      this.logMessage = JSON.stringify(error);
      return false;
    }

    return true;
  }
  kindValueChange($event: string) {
    //  [ { id:"TS" , name:"證券" },{ id:"TA" , name:"盤後" },{ id:"TL" , name:"零股" },{ id:"TP" , name:"興櫃" },{ id:"TC" , name:"盤中零股" },{ id:"TF" , name:"期貨" },{ id:"TO" , name:"選擇權" },{ id:"OF" , name:"海期" },{ id:"OO" , name:"海選" },{ id:"OS" , name:"複委託" } ]
    this.filterOpt.account = '';
    if (($event === 'TS') || ($event === 'TA') || ($event === 'TL') || ($event === 'TP') || ($event === 'TC')) {
      this.accountList = this.stkmbSrv.accountList;
    }
    if ($event === 'TF') {
      this.accountList = this.stkmbSrv.futureAccountList;
    }
    if ($event === 'OF') {
      this.accountList = this.stkmbSrv.seaAccountList;
    }
    if (this.accountList.length > 0)
      this.filterOpt.account = this.accountList[0].id
    else
      jkAlert('沒有帳號', 'W');
  }
  async doComfirm() {
    let item: any = this.masterGrid.itemFocused;
    if (!item) return;
    let ret = await this.stklmSrv.confirm(item, this.serverUrl);
    if (ret.result) {
      await this.showToast('回報成功');
    } else {
      await this.showAlert('回報失敗');
    }
  }

}
